import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDropzone } from 'react-dropzone';
import { X } from 'react-feather';
import PropTypes from 'prop-types';
import {
  customMessageNotification,
  notification,
} from '../../../../../utility/notification/notification.service';
import '../../../../../assets/scss/plugins/extensions/dropzone.scss';
import { isMobileDevice } from '../../../../../utility/util/util.service';

// this is intended to be used for CF Images
const ImageDropzone = ({
  propertyName,
  object,
  setter,
  previewUrl,
  setPreviewUrl,
  setUploadImage,
  isDisabled,
  messageId,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: [
      'image/jpeg',
      'image/png',
      'image/svg+xml',
      'image/webp',
      'image/gif',
    ], // https://developers.cloudflare.com/images/cloudflare-images/upload-images/formats-limitations
    multiple: false,
    maxSize: 10 * 1024 * 1024, // CF Images has 10 MB Limit
    disabled: isDisabled,
    onDropAccepted: (acceptedFiles) => {
      setUploadImage(acceptedFiles[0]);
      setPreviewUrl(URL.createObjectURL(acceptedFiles[0]));
    },
    onDropRejected: (rejectedFiles) =>
      rejectedFiles.forEach((fileRejection) =>
        fileRejection.errors.forEach((error) => {
          switch (error.code) {
            case 'file-too-large':
              notification('error', 'imageDropzoneErrorFileTooLarge');
              break;
            case 'file-too-small':
              notification('error', 'imageDropzoneErrorGeneral');
              break;
            case 'too-many-files':
              notification('error', 'imageDropzoneErrorTooManyFiles');
              break;
            case 'file-invalid-type':
              notification('error', 'imageDropzoneErrorInvalidType');
              break;
            default:
              customMessageNotification('error', error.message);
          }
        }),
      ),
  });

  const removeImage = () => {
    if (!isDisabled) {
      setUploadImage(null);
      setPreviewUrl(null);
      setter({ ...object, [propertyName]: null });
    }
  };

  return (
    <>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <span className="mx-1">
          <FormattedMessage
            id={
              messageId ||
              'imageDropzoneLabel' + (isMobileDevice() ? 'Mobile' : 'Desktop')
            }
          />
        </span>
      </div>
      {previewUrl && (
        <aside className="thumb-container">
          <div className="dz-thumb" key={1}>
            <div className="dz-thumb-inner">
              <img src={previewUrl} className="dz-img" alt="" width="100%" />
              <div className="dz-remove-button">
                <X className="white" size="18px" onClick={removeImage} />
              </div>
            </div>
          </div>
        </aside>
      )}
    </>
  );
};

ImageDropzone.propTypes = {
  propertyName: PropTypes.string,
  object: PropTypes.object,
  setter: PropTypes.func,
  previewUrl: PropTypes.string,
  setPreviewUrl: PropTypes.func,
  setUploadImage: PropTypes.func,
  placeholderId: PropTypes.string,
  isDisabled: PropTypes.bool,
  messageId: PropTypes.string,
};

export default ImageDropzone;
